import Vue from "vue";
import VueRouter from "vue-router";
import List from "@/views/List.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/users",
  },
  {
    path: "/users",
    name: "Utilisateurs",
    component: List,
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
